import dayjs from "dayjs";


export const GROUP_ADMIN = "AdminProd"
export const GROUP_VIEWER = "ViewerProd"
export const GROUP_STAGE = "AdminStage"


export function hasContent(string) {
    return string !== null && string !== undefined && string !== '' && string !== 'null';
}


export function getFromStorage(key) {
    return window.localStorage.getItem(key);
}

export function setInStorage(key, value) {
    window.localStorage.setItem(key, value)
}

export function saveHistory(campaignId, ev, type) {
    let editHistory = getFromStorage(`editHistory-${ev}`);
    editHistory = editHistory ? JSON.parse(editHistory) : []
    if (campaignId !== 'null' && !editHistory.includes(`${campaignId}|${type}`)) {
        editHistory.push(`${campaignId}|${type}`)
    }
    // window.dispatchEvent(new Event("previousEditsChanged"))
    window.localStorage.setItem(`editHistory-${ev}`, JSON.stringify(Array.from(editHistory)))
}

export function deleteHistory(ev) {
    window.localStorage.removeItem(`editHistory-${ev}`)
}


export function isEmpty(str) {
    return !str || str === '';
}

export function isValidInteger(num) {

    return /^-?(0|[1-9]\d*)$/.test(num);
}

export function isValidJson(str) {
    if (str ==='[]' || str === 'null') {
        return false;
    }
    try {
        JSON.parse(str);
        if (Array.isArray(JSON.parse(str))) {
            return false;
        }
    } catch (e) {
        return false;
    }
    return true;
}

export function containsRestrictedChars(str, chars) {
    for (const char of chars) {
        if (str.includes(char)) {
            return true;
        }
    }
    return false;
}

export function setSearchType(type, dispatch) {
    dispatch({
        type: 'TYPE_FILTER', payload: {
            data: {
                type: type
            }
        }
    });
}

export function sortAlphabeticallyByOneField(arr, fieldName) {
    arr.sort((a,b) => {

        const nameA = a[fieldName].toUpperCase();
        const nameB = b[fieldName].toUpperCase();

        if (nameA < nameB) {
            return -1;
        }
        if (nameA > nameB) {
            return 1;
        }
        return 0;
    })
}

export function getDuplicatesAndUniques(arr) {
    let uniques = new Set();
    let duplicates = new Set();

    let obj = {}

    arr.forEach(i => {
        if(obj.hasOwnProperty(i)) {
            obj[i] = obj[i] + 1;
        } else {
            obj[i] = 1;
        }
    })
    Object.keys(obj).forEach(key => {
        if (obj[key] === 1) {
            uniques.add(key)
        } else {
            duplicates.add(key)
        }
    })

    return {duplicates, uniques};
}

export function deepClone(obj) {
    return JSON.parse(JSON.stringify(obj));
}

export function convertToDayjs(unixTimestamp) {
    try {
        if (unixTimestamp < 9999999) {
            unixTimestamp = unixTimestamp * 1000
        }
        let d = dayjs(new Date(unixTimestamp * 1000)).set('second', 0);
        return d;
    } catch (e) {
        return ''
    }
}


function jwtDecode(token) {

    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
}
export function isTokenExpired(token) {
    try {
        const decodedToken = jwtDecode(token); // Use a library like jwt-decode
        const currentTime = new Date().getTime() / 1000;
        return decodedToken.exp < (currentTime+5*60);
    } catch (e) {
        return true;
    }
}


export function isProdAdmin(env, userSession) {
    return (env !== 'prod' && env !== 'production') || (userSession.user != null && Object.values(userSession.user).includes(GROUP_ADMIN));
}
export function isProdViewer(userSession) {
    return (userSession.user != null && Object.values(userSession.user).includes(GROUP_VIEWER));
}
export function isAdmin(userSession) {
    return (userSession.user != null && Object.values(userSession.user).includes(GROUP_ADMIN));
}
export function isStageAdmin(userSession) {
    return (userSession.user != null && Object.values(userSession.user).includes(GROUP_STAGE));
}
